/**
 * Supabase Client Instances
 * Manages different Supabase client configurations for different use cases
 */

import { createClient } from '@supabase/supabase-js';
import config from './config.js';

// Create the main Supabase client (for public access)
export const supabaseClient = createClient(
  config.supabaseUrl,
  config.supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true
    },
    db: {
      schema: 'public'
    },
    global: {
      headers: {
        'X-Client-Info': 'myclass-app'
      }
    }
  }
);

// Create admin Supabase client with service role (for authenticated access)
export const supabaseAdmin = createClient(
  config.supabaseUrl,
  config.supabaseServiceKey,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: false
    },
    db: {
      schema: 'public'
    },
    global: {
      headers: {
        'X-Client-Info': 'myclass-admin'
      }
    }
  }
);

// Create a read-only client for public data access
export const supabaseReadOnly = createClient(
  config.supabaseUrl,
  config.supabaseAnonKey,
  {
    auth: {
      autoRefreshToken: false,
      persistSession: false
    },
    db: {
      schema: 'public'
    },
    global: {
      headers: {
        'X-Client-Info': 'myclass-readonly'
      }
    }
  }
);

// Export the default client for backward compatibility
export const supabase = supabaseClient;

// Client factory for creating specialized clients
export const createSpecializedClient = (options = {}) => {
  const {
    key = config.supabaseAnonKey,
    auth = {},
    db = {},
    global = {}
  } = options;

  return createClient(config.supabaseUrl, key, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      ...auth
    },
    db: {
      schema: 'public',
      ...db
    },
    global: {
      headers: {
        'X-Client-Info': 'myclass-specialized',
        ...global.headers
      },
      ...global
    }
  });
};

// Export all clients for use in services
export default {
  client: supabaseClient,
  admin: supabaseAdmin,
  readOnly: supabaseReadOnly,
  createSpecialized: createSpecializedClient
};
